import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { App } from './App';
import { localAuthEnabled } from './lib/localAuth';
import { registrarServiceWorker } from './pwa/registerSw';
import './index.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const root = () => ReactDOM.createRoot(document.getElementById('root')!);

// PWA: registra o SW (com auto-update) em qualquer modo de auth. Idempotente e
// à prova de falha — nunca derruba o boot do app.
registrarServiceWorker();

if (localAuthEnabled()) {
  // Modo local (VITE_AUTH_DISABLED): login local, SEM Clerk. Não exige chave.
  root().render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else if (!PUBLISHABLE_KEY) {
  // Mensagem clara em dev se a chave do Clerk não estiver configurada.
  document.getElementById('root')!.innerHTML =
    '<div style="padding:40px;font-family:Inter,sans-serif;color:#16181C;background:#F6F7F8;height:100vh">' +
    '<h1>Configuração faltando</h1><p>Defina <code>VITE_CLERK_PUBLISHABLE_KEY</code> no seu <code>.env</code> ' +
    '(ou use <code>VITE_AUTH_DISABLED=true</code> para o modo local). Veja o <code>.env.example</code>.</p></div>';
} else {
  root().render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        appearance={{ variables: { colorPrimary: '#0E7C5A', colorBackground: '#FFFFFF' } }}
      >
        <App />
      </ClerkProvider>
    </React.StrictMode>,
  );
}
